import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Button,
  TextField,
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  InputAdornment,
  TableHead,
  TablePagination,
  IconButton
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import Autocomplete from '@mui/material/Autocomplete';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { actualizarUnidadDeActivo, addActivoUnidad, cargarCatalogoIess, createActivo, deleteActivo, getActivosPorEmpresa, updateActivo } from '../../services/activos/activosData';
import { getTiposActivos } from '../../services/activos/tiposActivos/tiposActivosData';
import { useAuth } from "../../context/AuthContext";
import { getUnidadesPorEmpresa, getUnidadPorActivo } from '../../services/unidades/unidadesData';
import { toast } from "react-toastify";

const TablaGA = () => {
  const [datos, setDatos] = useState([]);
  const [tipos, setTipos] = useState([]);
  const [tiposIds, setTiposIds] = useState([]);
  const [intentoGuardar, setIntentoGuardar] = useState(false);
  const [unidadesOptions, setUnidadesOptions] = useState([]);
  const { user } = useAuth();
  const [modalOpen, setModalOpen] = useState(false);
  const [busqueda, setBusqueda] = useState('');
  const [modificarIndex, setModificarIndex] = useState(-1);
  const emp_codigo = user?.emp_codigo;
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [codigoToDelete, setCodigoToDelete] = useState(null);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [catalogoOpen, setCatalogoOpen] = useState(false);
  const [unidadCatalogo, setUnidadCatalogo] = useState(null);
  const [cargandoCatalogo, setCargandoCatalogo] = useState(false);

  // Pagination state
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const datosFiltrados = Array.isArray(datos)
    ? datos.filter((dato) =>
      dato.act_nombre && dato.act_nombre.toLowerCase().includes(busqueda.toLowerCase())
    )
    : [];

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (emp_codigo) {
          const activosData = await getActivosPorEmpresa(emp_codigo);
          setDatos(Array.isArray(activosData) ? activosData : []);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        setDatos([]);
      }
    };
    fetchData();
  }, [emp_codigo]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const tiposActivosData = await getTiposActivos();
        setTipos(Array.isArray(tiposActivosData) ? tiposActivosData : []);
      } catch (error) {
        console.error('Error fetching data:', error);
        setTipos([]);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (Array.isArray(tipos) && tipos.length > 0) {
      const tiposIds1 = tipos.map((item) => ({
        label: item.tac_descripcion,
        value: item.tac_codigo
      }));
      setTiposIds(tiposIds1);
    } else {
      setTiposIds([]);
    }
  }, [tipos]);

  useEffect(() => {
    const fetchUnidades = async () => {
      try {
        if (emp_codigo) {
          const unidadesData = await getUnidadesPorEmpresa(emp_codigo);
          const opciones = unidadesData.map(u => ({
            label: u.uni_nombre,
            value: u.uni_nombre,
            codigo: u.uni_codigo,
          }));
          setUnidadesOptions(opciones);
        }
      } catch (error) {
        console.error('Error fetching unidades:', error);
      }
    };
    fetchUnidades();
  }, [emp_codigo]);

  const [formulario, setFormulario] = useState({
    Tipo: '',
    FechaInicio: '',
    Identificacion: '',
    Nombre: '',
    Unidad: '',
    Descripción: '',
    Observacion: '',
    Valor: '',
    FechaInactividad: null,
  });

  // Obtener la descripción del tipo de activo a partir de su código
  const getTipoDescripcion = (codigo) => {
    const tipo = tipos.find((t) => t.tac_codigo === codigo);
    return tipo ? tipo.tac_descripcion : codigo;
  };

  const handleBusquedaChange = (event) => {
    setBusqueda(event.target.value);
    setPage(0);
  };

  const handleDateChange = (newValue) => {
    const formattedDate = dayjs(newValue).format('YYYY-MM-DD');
    setFormulario({
      ...formulario,
      FechaInicio: formattedDate,
    });
  };

  const handleInsert = () => {
    setModificarIndex(-1);
    setFormulario({
      Tipo: '',
      FechaInicio: '',
      Identificacion: '',
      Nombre: '',
      Descripción: '',
      Observacion: '',
      Valor: '',
      FechaInactividad: null,
    });
    setModalOpen(true);
  };

  const handleAbrirCatalogo = () => {
    setUnidadCatalogo(null);
    setCatalogoOpen(true);
  };

  const handleCargarCatalogo = async () => {
    if (!unidadCatalogo) {
      toast.error("Seleccione la unidad a la que se asignará el catálogo IESS.");
      return;
    }

    setCargandoCatalogo(true);
    try {
      const resultado = await cargarCatalogoIess({
        emp_codigo: Number(emp_codigo),
        uni_codigo: unidadCatalogo.codigo,
      });
      toast.success(
        `Catálogo IESS listo: ${resultado.assetsCreated} activos nuevos y ${resultado.assetsAlreadyPresent} ya existentes.`
      );
      const activosData = await getActivosPorEmpresa(emp_codigo);
      setDatos(Array.isArray(activosData) ? activosData : []);
      setCatalogoOpen(false);
    } catch (error) {
      toast.error(error?.message || "No se pudo cargar el catálogo IESS.");
    } finally {
      setCargandoCatalogo(false);
    }
  };

  const handleFormChange = (event) => {
    setFormulario({
      ...formulario,
      [event.target.name]: event.target.value,
    });
  };

  function generarIdentificador() {
    const letras = Array.from({ length: 3 }, () =>
      String.fromCharCode(65 + Math.floor(Math.random() * 26))
    ).join('');
    const numeros = String(Math.floor(100 + Math.random() * 900));
    return `${letras}-${numeros}`;
  }

  const buildActivoPayload = (overrides = {}, includeEmpresa = false) => {
    const payload = {
      tac_codigo: formulario.Tipo ? Number(formulario.Tipo) : null,
      act_fecha_inicio: formulario.FechaInicio ? dayjs(formulario.FechaInicio).format('YYYY-MM-DD') : null,
      act_identificacion: overrides.act_identificacion ?? formulario.Identificacion,
      act_nombre: formulario.Nombre?.trim(),
      act_descripcion: formulario.Descripción?.trim(),
      act_fecha_inactividad: formulario.FechaInactividad
        ? dayjs(formulario.FechaInactividad).format('YYYY-MM-DD')
        : null,
      act_observacion: formulario.Observacion?.trim(),
      act_valor: formulario.Valor === '' ? null : Number(formulario.Valor),
      ...overrides
    };

    if (includeEmpresa) {
      payload.emp_codigo = emp_codigo;
    }

    return payload;
  };

  const handleGuardar = async () => {
    setIntentoGuardar(true);
    const camposFaltantes = [];
    if (!formulario.Tipo) camposFaltantes.push("Tipo de Activo");
    if (!formulario.FechaInicio) camposFaltantes.push("Fecha de Inicio");
    if (!formulario.Nombre) camposFaltantes.push("Nombre");
    if (!formulario.Unidad) camposFaltantes.push("Unidad");
    if (!formulario.Descripción) camposFaltantes.push("Descripción");
    if (!formulario.Observacion) camposFaltantes.push("Observación");
    if (!formulario.Valor) camposFaltantes.push("Valor");
    if (Number(formulario.Valor) <= 0) {
      toast.error("El valor debe ser un número positivo mayor a cero.");
      return;
    }
    if (camposFaltantes.length > 0) {
      toast.error(`Faltan campos obligatorios: ${camposFaltantes.join(", ")}`);
      return;
    }
    try {
      if (modificarIndex !== -1) {
        const payload = buildActivoPayload();
        await updateActivo(modificarIndex, payload);
        toast.success("Activo modificado correctamente");
        if (formulario.Unidad) {
          await actualizarUnidadDeActivo(modificarIndex, formulario.Unidad, user.emp_codigo);
        }
        const activosData = await getActivosPorEmpresa(emp_codigo);
        setDatos(Array.isArray(activosData) ? activosData : []);
      } else {
        const identificador = generarIdentificador();
        const payload = buildActivoPayload(
          { act_identificacion: identificador },
          true
        );
        const activoCreado = await createActivo(payload);

        if (activoCreado && activoCreado.act_codigo && formulario.Unidad) {
          const unidadSeleccionada = unidadesOptions.find(opt => opt.value === formulario.Unidad);
          if (unidadSeleccionada) {
            const unidadesData = await getUnidadesPorEmpresa(emp_codigo);
            const unidadObj = unidadesData.find(
              u => u.uni_nombre === unidadSeleccionada.label
            );
            if (unidadObj) {
              await addActivoUnidad(unidadObj.uni_codigo, activoCreado.act_codigo);
            }
          }
        }
        toast.success("Activo creado correctamente");
        const activosData = await getActivosPorEmpresa(emp_codigo);
        setDatos(Array.isArray(activosData) ? activosData : []);
      }

      setModalOpen(false);
      setFormulario({
        Tipo: '',
        FechaInicio: '',
        Identificacion: '',
        Nombre: '',
        Unidad: '',
        Descripción: '',
        Observacion: '',
        Valor: '',
        FechaInactividad: null,
      });
      setIntentoGuardar(false);
    } catch (error) {
      if (
        error?.code === "ER_DUP_ENTRY" ||
        error?.errno === 1062 ||
        (error?.response?.data?.code === "ER_DUP_ENTRY") ||
        (error?.response?.data?.errno === 1062)
      ) {
        toast.error("Ya existe una relación entre este activo y la unidad seleccionada. No se permiten duplicados.");
      } else {
        toast.error("Error al guardar el activo");
      }
    }
  };

  const handleCancelar = () => {
    setModalOpen(false);
    setFormulario({
      Tipo: '',
      FechaInicio: '',
      Identificacion: '',
      Nombre: '',
      Descripción: '',
      Observacion: '',
      Valor: '',
      FechaInactividad: null,
    });
  };
  const handleFechaInactividadChange = (newValue) => {
    const formattedDate = newValue ? dayjs(newValue).format('YYYY-MM-DD') : null;
    setFormulario({
      ...formulario,
      FechaInactividad: formattedDate,
    });
  };

  const handleModificar = async (codigo) => {
    const activo = datos.find(d => d.act_codigo === codigo);

    const formattedFechaInicio = activo?.act_fecha_inicio
      ? dayjs(activo.act_fecha_inicio).format('YYYY-MM-DD')
      : '';
    const formattedFechaInactividad = activo?.act_fecha_inactividad
      ? dayjs(activo.act_fecha_inactividad).format('YYYY-MM-DD')
      : '';

    let unidadNombre = '';
    try {
      const unidad = await getUnidadPorActivo(activo.act_codigo);
      unidadNombre = unidad?.uni_nombre || '';
    } catch (e) {
      unidadNombre = '';
    }

    setModificarIndex(activo.act_codigo);
    setFormulario({
      Tipo: activo.tac_codigo,
      FechaInicio: formattedFechaInicio,
      Identificacion: activo.act_identificacion,
      Nombre: activo.act_nombre,
      Unidad: unidadNombre,
      Descripción: activo.act_descripcion,
      Observacion: activo.act_observacion,
      Valor: activo.act_valor,
      FechaInactividad: formattedFechaInactividad,
    });
    setModalOpen(true);
  };

  const handleEliminar = (codigo) => {
    setCodigoToDelete(codigo);
    setConfirmOpen(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await deleteActivo(codigoToDelete);
      toast.success("Activo eliminado correctamente");
      const activosData = await getActivosPorEmpresa(emp_codigo);
      setDatos(Array.isArray(activosData) ? activosData : []);
      setConfirmOpen(false);
      setCodigoToDelete(null);
    } catch (error) {
      setConfirmOpen(false);
      
      // El interceptor de axios transforma el error, así que el mensaje está en error.message
      // y el status está en error.status (no error.response.status)
      const errorMsg = error?.message || 
                       error?.response?.data?.message || 
                       error?.response?.data?.error ||
                       "No se puede eliminar el activo porque está siendo utilizado en el sistema.";
      
      const errorStatus = error?.status || error?.response?.status;
      
      // Si es un error 400 o el mensaje indica que no se puede eliminar, mostrar modal
      if (errorStatus === 400 || errorMsg.toLowerCase().includes('no se puede eliminar') || 
          errorMsg.toLowerCase().includes('asociado') || errorMsg.toLowerCase().includes('relacionado')) {
        setErrorMessage(errorMsg);
        setErrorModalOpen(true);
      } else if (
        error?.response?.data?.errno === 1451 ||
        error?.response?.data?.code === "ER_ROW_IS_REFERENCED_2" ||
        error?.response?.data?.code === "ER_ROW_IS_REFERENCED"
      ) {
        setErrorMessage("No se puede eliminar el activo porque está relacionado con otras tablas.");
        setErrorModalOpen(true);
      } else {
        toast.error(errorMsg);
      }
      setCodigoToDelete(null);
    }
  };

  const handleCancelDelete = () => {
    setConfirmOpen(false);
    setCodigoToDelete(null);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Box>
      {/* Toolbar */}
      <Box sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #e0e0e0', flexWrap: 'wrap', gap: 2 }}>
        <TextField
          variant="outlined"
          size="small"
          placeholder="Buscar activo..."
          value={busqueda}
          onChange={handleBusquedaChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          sx={{ width: { xs: '100%', sm: 300 } }}
        />
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          <Button
            variant="outlined"
            onClick={handleAbrirCatalogo}
            disabled={!emp_codigo || unidadesOptions.length === 0}
            sx={{ textTransform: 'none', fontWeight: 500 }}
          >
            Cargar catálogo IESS
          </Button>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleInsert}
            sx={{
              backgroundColor: '#001F3F',
              color: '#fff',
              '&:hover': { backgroundColor: '#003366' },
              textTransform: 'none',
              fontWeight: 500,
            }}
          >
            Nuevo Activo
          </Button>
        </Box>
      </Box>

      <TableContainer>
        <Table sx={{ minWidth: 750 }}>
          <TableHead>
            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
              <TableCell sx={{ fontWeight: 600, color: '#001F3F' }}>Tipo</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#001F3F' }}>Fecha Inicio</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#001F3F' }}>Identificación</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#001F3F' }}>Nombre</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#001F3F' }}>Descripción</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#001F3F' }}>Observación</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#001F3F' }}>Valor</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#001F3F' }}>Inactividad</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#001F3F' }} align="center">Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {datosFiltrados.length === 0 ? (
              <TableRow>
                <TableCell colSpan={9} align="center" sx={{ py: 4 }}>
                  <Typography variant="body1" sx={{ color: '#666' }}>
                    {datos.length === 0 ? "No hay activos registrados" : "No se encontraron resultados"}
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              datosFiltrados
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((dato) => (
                  <TableRow key={dato.act_codigo} hover>
                    <TableCell>{getTipoDescripcion(dato.tac_codigo)}</TableCell>
                    <TableCell>
                      {dato.act_fecha_inicio
                        ? (dato.act_fecha_inicio || '').split('T')[0]
                        : '-'}
                    </TableCell>
                    <TableCell>{dato.act_identificacion}</TableCell>
                    <TableCell>
                      <Typography variant="body2" sx={{ color: '#001F3F', fontWeight: 500 }}>
                        {dato.act_nombre}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ maxWidth: 200, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      <Typography variant="body2" sx={{ color: '#666' }}>
                        {dato.act_descripcion || '-'}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ maxWidth: 200, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      <Typography variant="body2" sx={{ color: '#666' }}>
                        {dato.act_observacion || '-'}
                      </Typography>
                    </TableCell>
                    <TableCell>{dato.act_valor}</TableCell>
                    <TableCell>
                      {dato.act_fecha_inactividad
                        ? (dato.act_fecha_inactividad || '').split('T')[0]
                        : '-'}
                    </TableCell>
                    <TableCell align="center">
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                        <IconButton
                          onClick={() => handleModificar(dato.act_codigo)}
                          size="small"
                          sx={{ color: "#666" }}
                        >
                          <EditIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                          onClick={() => handleEliminar(dato.act_codigo)}
                          size="small"
                          sx={{ color: "#d32f2f" }}
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={datosFiltrados.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        labelRowsPerPage="Filas por página:"
      />

      {/* Ventana emergente */}
      <Dialog
        open={modalOpen}
        onClose={handleCancelar}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ pb: 2, fontWeight: 600, color: '#001F3F', fontSize: '1.25rem' }}>
          {modificarIndex !== -1 ? 'Modificar Activo' : 'Nuevo Activo'}
        </DialogTitle>
        <DialogContent sx={{ pt: 3 }}>
          <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Box sx={{ display: 'flex', gap: 2 }}>
              <Autocomplete
                disablePortal
                id="combo-box-demo"
                name="Tipo"
                value={tiposIds.find(opt => opt.value === formulario.Tipo) || null}
                options={tiposIds}
                sx={{ flex: 1 }}
                getOptionLabel={(option) => option?.label || ""}
                onChange={(event, newValue) => {
                  setFormulario({
                    ...formulario,
                    Tipo: newValue ? newValue.value : "",
                  });
                }}
                renderInput={(params) => <TextField {...params} label="Tipo de Activo" />}
              />
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Fecha de Inicio"
                  name="FechaInicio"
                  value={formulario.FechaInicio ? dayjs(formulario.FechaInicio) : null}
                  onChange={handleDateChange}
                  minDate={dayjs()}
                  sx={{ flex: 1 }}
                  slotProps={{
                    textField: {
                      error: intentoGuardar && !formulario.FechaInicio,
                      helperText: intentoGuardar && !formulario.FechaInicio ? "La fecha es obligatoria" : "",
                    }
                  }}
                />
              </LocalizationProvider>
            </Box>

            <TextField label="Nombre" name="Nombre" fullWidth value={formulario.Nombre} onChange={handleFormChange} />

            <Autocomplete
              disablePortal
              id="combo-box-unidad"
              name="Unidad"
              value={unidadesOptions.find(opt => opt.value === formulario.Unidad) || null}
              options={unidadesOptions.length > 0 ? unidadesOptions : [{ label: "No hay unidades por el momento", value: "" }]}
              fullWidth
              getOptionLabel={(option) => option?.label || ""}
              onChange={(event, newValue) => {
                setFormulario({
                  ...formulario,
                  Unidad: newValue ? newValue.value : "",
                });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Unidad"
                  inputProps={{ ...params.inputProps, readOnly: true }}
                />
              )}
              disabled={unidadesOptions.length === 0}
            />
            <TextField label="Descripción" name="Descripción" fullWidth multiline rows={2} value={formulario.Descripción} onChange={handleFormChange} />
            <TextField label="Observación" name="Observacion" fullWidth multiline rows={2} value={formulario.Observacion} onChange={handleFormChange} />
            <TextField label="Valor" type="number" name="Valor" inputProps={{ min: 2 }} fullWidth value={formulario.Valor} onChange={(e) => {
              let value = e.target.value.replace(/[^0-9]/g, "");
              if (value.length > 1 && value[0] === "0") {
                value = value.replace(/^0+/, "");
                if (value === "") value = "0";
              }
              setFormulario({
                ...formulario,
                Valor: value,
              });
            }} />
            {modificarIndex !== -1 ?
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Fecha de Inactividad (Opcional)"
                  name="FechaInactividad"
                  value={formulario.FechaInactividad ? dayjs(formulario.FechaInactividad) : null}
                  onChange={handleFechaInactividadChange}
                  slotProps={{
                    textField: {
                      helperText: "Solo usar si el activo fue retirado/desactivado"
                    }
                  }}
                />
              </LocalizationProvider>
              : null}
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handleCancelar} sx={{ color: '#666' }}>Cancelar</Button>
          <Button
            onClick={handleGuardar}
            variant="contained"
            sx={{
              backgroundColor: '#001F3F',
              color: '#fff',
              '&:hover': { backgroundColor: '#003366' }
            }}
          >
            Guardar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={catalogoOpen}
        onClose={() => !cargandoCatalogo && setCatalogoOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: 600, color: '#001F3F' }}>
          Cargar catálogo base IESS
        </DialogTitle>
        <DialogContent>
          <Typography sx={{ color: '#666', mb: 2 }}>
            Se agregarán 23 activos de Hardware, Software, Red y Personal a la unidad elegida. Los activos ya cargados no se borran ni se duplican.
          </Typography>
          <Autocomplete
            options={unidadesOptions}
            value={unidadCatalogo}
            getOptionLabel={(option) => option?.label || ''}
            onChange={(event, newValue) => setUnidadCatalogo(newValue)}
            renderInput={(params) => <TextField {...params} label="Unidad destino" />}
          />
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => setCatalogoOpen(false)} disabled={cargandoCatalogo} sx={{ color: '#666' }}>
            Cancelar
          </Button>
          <Button
            variant="contained"
            onClick={handleCargarCatalogo}
            disabled={cargandoCatalogo || !unidadCatalogo}
            sx={{ backgroundColor: '#001F3F', '&:hover': { backgroundColor: '#003366' } }}
          >
            {cargandoCatalogo ? 'Cargando…' : 'Cargar catálogo'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Confirmación de eliminación */}
      <Dialog
        open={confirmOpen}
        onClose={handleCancelDelete}
      >
        <DialogTitle sx={{ fontWeight: 600, color: '#001F3F', fontSize: '1.25rem' }}>
          Confirmar Eliminación
        </DialogTitle>
        <DialogContent>
          <Typography sx={{ color: '#666' }}>
            ¿Está seguro que desea eliminar este activo?
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handleCancelDelete} sx={{ color: '#666' }}>Cancelar</Button>
          <Button 
            onClick={handleConfirmDelete} 
            variant="contained"
            sx={{
              backgroundColor: '#d32f2f',
              color: '#fff',
              '&:hover': { backgroundColor: '#c62828' }
            }}
          >
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal de Error al Eliminar */}
      <Dialog
        open={errorModalOpen}
        onClose={() => setErrorModalOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: 600, color: '#001F3F', fontSize: '1.25rem', pb: 2 }}>
          No se puede eliminar
        </DialogTitle>
        <DialogContent>
          <Box sx={{ py: 2 }}>
            <Typography variant="body1" sx={{ color: '#666', mb: 2 }}>
              {errorMessage || 'Este activo no puede ser eliminado porque está siendo utilizado en el sistema.'}
            </Typography>
            <Typography variant="body2" sx={{ color: '#999', fontSize: '0.9rem' }}>
              Para poder eliminar este activo, primero debe eliminar o modificar todas las relaciones asociadas.
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button 
            onClick={() => setErrorModalOpen(false)} 
            variant="contained"
            sx={{
              backgroundColor: '#001F3F',
              color: '#fff',
              '&:hover': { backgroundColor: '#003366' }
            }}
          >
            Entendido
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default TablaGA;
